import { createLogger } from '@svs/nova-core/log';

const logger = createLogger('poolbetting.sportinfo.sportradar');

/**
 * Retrieves the Sportradar ID token from environment variables.
 *
 * @returns The ID token as a string.
 */
export function getSportradarIdToken(): string {
  const token = process.env['NEXT_PUBLIC_SPORTINFO_SPORTRADAR_ID'];
  if (!token) {
    logger.warn('SPORTINFO_SPORTRADAR_ID environment variable is not set');
    return '';
  }

  return token;
}
